<div >
    <app-breadcrumb
            [firstNode]="{label: 'Users list', 'url': '/home'}">
    </app-breadcrumb>

    <app-admin-navigation
        [params]="{page: 'SERVICEPROVIDERS'}" [type]="'SEVICE_PROVIDER'">
    </app-admin-navigation>

    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="card--box__header__title">
                    {{ 'Service providers Management' | translate }}
                </div>
                <div class="card--box__header--action text-xs-right">
                    <span class="card--box__header__action float-xs-right">
                        <button type="button" class="btn btn-link  card--box__header__action__button" (click)="openFormModal({action: 'create', title: 'Add Service provider', url: '/service-providers'});">
                            <i class="fas fa-plus-circle"></i>
                            <span class="hidden-sm-down">{{ 'Add Service provider' | translate}}</span>
                        </button>
                    </span>
                </div>
            </div>

            <app-admin-setting-search [searchInfo]="searchInfo" [languages]="languages" [itemLanguage]="itemLanguage" (searchData)="searchItems()" (changeLanguage)="submitChangeLanguage($event)"></app-admin-setting-search>
        </div>
        <div class="table--grid">
            <div class="table--grid__body">
                <app-admin-setting-header class="row" [tableColumns]="tableColumns" [itemLanguage]="itemLanguage" [sortIsActivated]="sortIsActivated" [sortedColumn]="sortedColumn" [order]="order" (sortAction)="sort($event);"> </app-admin-setting-header>

                <!--table cells-->
                <ng-container *ngIf="items && items.length; else empty">
                    <ng-container *ngFor="let serviceProvider of items">
                        <div class="row">
                            <!--group header button for table-->
                            <div class="col-xs-12" (click)="openFormModal({ action: 'read', id: serviceProvider['id'], title: 'Service provider Details', activated: serviceProvider['activated'], content: serviceProvider['activated'] ? 'Are you sure you want to deactivate this domain text?' : 'Are you sure you want to activate this domain text?', description: serviceProvider['name'], url: '/service-providers' });">
                                <div class="row">
                                    <div *ngFor="let column of tableColumns" class="{{ column[2] }}">
                                        <ng-template [ngIf]="column[3] === 'website'" [ngIfElse]="isTranslateColumn">
                                            {{ serviceProvider[column[0]] }}
                                        </ng-template>
                                        <ng-template #isTranslateColumn>
                                            {{ serviceProvider[column[0] + itemLanguage] | translate }}
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                            <app-admin-setting-actions (editData)="openFormModal({action: 'update', id: serviceProvider['id'], title: 'Update Service provider', url: 'domain-texts'});" (deleteData)="delete(serviceProvider)"></app-admin-setting-actions>
                        </div>
                    </ng-container>
                </ng-container>
               
                <ng-template #empty>
                    <div class="text-xs-center pd-v--sm">
                        {{ 'No item is matched your search criteria.' | translate }}
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <!--pagination-->
    <pagination-component *ngIf="!paginationHidden"
                          [(page)]="currentPage"
                          [total]="totalItems"
                          [perPage]="itemsPerPage"
                          [limit]="maxSize" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginate($event)" #pagination>

    </pagination-component>
    <div class="mt-1 mb-1"></div>

    <!-- Modal -->
    <div bsModal #modal="bs-modal" class="modal fade modal-edit-service-providers" [ngClass]="params['action'] === 'activate' || params['action'] === 'delete' ? 'modal-confirmation': ''" tabindex="-1" role="dialog" aria-hidden="true">

        <div class="modal-dialog">
            <service-provider-modal-component
                [diagnoses]="diagnoses"
                [categories]="categories"
                [subcategories]="subcategories"
                [companies]="companies"
                [ageGroups]="ageGroups"
                [serviceProviderLanguage]="serviceProviderLanguage"
                [countries]="countries"
                [insurances]="insurances"
                [logoPath]="logoPath"
                [logos]="logos"
                [params]="params"
                [itemLanguage]="itemLanguage"
                [formLoading]="formLoading"
                [form]="form"
                [formSubmitted]="formSubmitted"
                [languages]="languages"
                [authService]="authService"
                (hideModal)="hideModal()"
                (submit)="submit(form.value, form.valid, url, true)"
                (openFormModal)="openFormModal({ action: 'update', id: params['id'], title: 'Update Service provider', url: 'domain-texts' })"
                (delete)="delete(params)"
                >
            </service-provider-modal-component>
        </div>
    </div>
    <!--close <div bsModal ...-->

    <div bsModal #modalDeleteServiceProviders="bs-modal" class="modal fade modal-confirmation" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-confirmation-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-body text-xs-center">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="modal-icon">
                                <i class="far fa-trash-alt" ng-class="icon" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 modal-title">
                            {{ 'Delete service provider confirmation' | translate }}
                        </div>
                        <div class="col-xs-12 modal-content">
                            {{ 'Are you sure you want to delete this service provider?' | translate }}
                            <br/>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col-xs-12 text-xs-right">
                            <button type="button" class="btn btn-secondary " (click)="this.modalDeleteServiceProviders.hide()">
                                <i class="fas fa-ban"></i>
                                {{ 'Cancel' | translate }}
                            </button>
                            <button type="button" class="btn btn-primary " (click)="submitDelete()">
                                <i class="fas fa-check"></i>
                                {{ 'OK' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<dialog-component #dialog></dialog-component>
<dialog-component #dialogLogo></dialog-component>
